import type { BookingType } from '@shared/modules/booking-types/booking-type';
import type { ClientMedication } from '@shared/modules/client-medication/client-medication';
import type { ClientScheduleEntry } from '@shared/modules/client-schedule-entries/client-schedule-entry';
import type { ClientTaskCompletion } from '@shared/modules/client-task-completions/client-task-completion';
import type {
    ClientTaskScheduleEntryPresenter
} from '@shared/modules/client-task-schedule-entries/client-task-schedule-entry.presenter';
import type { TaskImportance } from '@shared/modules/client-task-schedule-entries/task-importance.enum';
import type { Client } from '@shared/modules/clients/client';
import type { ScheduleEntry } from '@shared/modules/schedule/schedule-entries';

export enum RecurrenceType {
    linked = 'linked',
    schedule = 'schedule',
    rrule = 'rrule'
}

export enum ClientTaskScheduleEntryType {
    task = 'task',
    medication = 'medication'
}

export interface ClientTaskScheduleEntryRestrictions {
    can_update_linked_to: boolean;
    can_update_applies_until: boolean;
}

export interface ClientTaskScheduleEntry extends ScheduleEntry {
    id: string;
    client_id: string;

    day: number[];
    week: number[];

    content: string;
    type: ClientTaskScheduleEntryType;
    client_medication_id: string;
    medication_dosage: string;
    override_medication_dates: boolean;
    finish: string;
    private_notes: string;

    linked_to_type?: string;
    linked_to_id?: string;

    booking_types?: { data: BookingType[] };
    client?: { data: Client };
    client_medication?: { data: ClientMedication };
    completions?: { data: ClientTaskCompletion[] };
    linked_to?: { data: ClientScheduleEntry };

    last_completion?: { data: ClientTaskCompletion };
    completions_count?: number;

    deactivated_at?: string;

    sort_order?: number;
    importance?: TaskImportance;
    last_edited_at?: string;

    restrictions?: {
        data: ClientTaskScheduleEntryRestrictions;
    };

    presenter?: ClientTaskScheduleEntryPresenter;
}
